import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Seo from "@/components/Seo";

export function Breadcrumbs({ items }) {
  if (!items || items.length <= 1) return null;
  return (
    <nav aria-label="breadcrumb" className="mb-6" data-testid="breadcrumbs">
      <ol className="flex flex-wrap items-center gap-1.5 text-sm text-slate-400">
        {items.map((b, i) => (
          <li key={b.to} className="flex items-center gap-1.5">
            {i > 0 && <ChevronRight className="w-3.5 h-3.5" />}
            {i === items.length - 1
              ? <span className="text-slate-600 font-medium">{b.label}</span>
              : <Link to={b.to} className="hover:text-slate-700">{b.label}</Link>}
          </li>
        ))}
      </ol>
    </nav>
  );
}

export default function SiteLayout({ children, seo, breadcrumbs, narrow = false }) {
  return (
    <div className="min-h-screen bg-[#F7F9FC] flex flex-col">
      {seo && <Seo {...seo} breadcrumbs={breadcrumbs} />}
      <Navbar />
      <main className={`flex-1 w-full mx-auto px-5 py-10 sm:py-14 ${narrow ? "max-w-3xl" : "max-w-6xl"}`}>
        <Breadcrumbs items={breadcrumbs} />
        {children}
      </main>
      <Footer />
    </div>
  );
}
